module.exports = __webpack_public_path__ + "media/sound_completed_1.7a5e59ed.mp3";